import { Component, OnInit } from '@angular/core';
import { CurrentSubscriptionModel } from '../../models/current-subscription.model';
import { CurrentSubscriptionService } from '../../services/current-subscription.service';
import { PlanService } from '../../services/plan.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { ResponsibleService } from '../../services/responsible.service';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { CreditCardModel } from '../../models/creditCard.model';

@Component({
  selector: 'app-current-subscription',
  templateUrl: './current-subscription.component.html',
  styleUrls: ['./current-subscription.component.less']
})
export class CurrentSubscriptionComponent implements OnInit {


  subscriptions: Array<CurrentSubscriptionModel> = new Array<CurrentSubscriptionModel>();
  paymentMethods: InputSelectModel[] = new Array<InputSelectModel>();
  hasDependents = true;

  constructor(private currentSubscriptionService: CurrentSubscriptionService, private planService: PlanService,
    private notificationService: NotificationService, private responsibleService: ResponsibleService) { }

  ngOnInit() {
    this.getCurrentSubscriptions();
  }

  private getCurrentSubscriptions() {
    this.currentSubscriptionService.getAll()
      .then((_subscriptions: Array<CurrentSubscriptionModel>) => {
        if (_subscriptions.length === 0) {
          this.hasDependents = false;
          this.subscriptions = [];
        } else {
          this.getPaymentMethods();

          _subscriptions.forEach(() => {
            this.subscriptions = _subscriptions;
          });
        }
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private getPaymentMethods() {
    this.responsibleService.getCreditCards()
      .then((_creditCards) => {
        this.paymentMethods = new Array<InputSelectModel>();
        _creditCards.forEach((creditCard: CreditCardModel) => {
          this.paymentMethods.push({ title: `**** **** **** ${creditCard.finalNumero}`, value: creditCard.id });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  changePaymentMethod(subscriptionId: string, paymentMethodSelectedId: string) {
    this.notificationService.showQuestionNotification('Deseja alterar o cartão de cobrança da assinatura?')
      .then(result => {
        if (result.value) {
          this.currentSubscriptionService.changePaymentMethod(subscriptionId, paymentMethodSelectedId)
            .then(() => {
              this.notificationService.showSuccessNotification('Cartão alterado!');
            })
            .catch((err) => {
              this.notificationService.showErrorNotification(err.message ? err.message : err.errors[0].messages[0]);
              this.getCurrentSubscriptions();
            });
        } else {
          this.getCurrentSubscriptions();
        }
      });
  }


  cancel(subscriptionId: string) {
    this.notificationService.showQuestionNotification('Você tem certeza que deseja cancelar a assinatura?')
      .then(result => {
        if (result.value) {
          this.planService.cancel(subscriptionId)
            .then(() => {
              this.notificationService.showSuccessNotification('Cancelada com sucesso!')
                .then(() => {
                  this.getCurrentSubscriptions();
                });
            })
            .catch((err) => this.notificationService.showErrorNotification(err.message ? err.message : err.errors[0].messages[0]));
        }
      });

  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/current-subscription/current-subscription.component.ts